webpackJsonp([9],{

/***/ 13:
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(18)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ 18:
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 35:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchDropdown_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea91c3ca_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchDropdown_vue__ = __webpack_require__(39);
function injectStyle (ssrContext) {
  __webpack_require__(36)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea91c3ca_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(37);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(14)("19ed656e", content, true, {});

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(13)(undefined);
// imports


// module
exports.push([module.i, "@-webkit-keyframes linkUnderlineAnimation{0%{background-size:100% 100%,0 100%}25%{background-size:50% 100%,0 100%}50%{background-size:0 100%,0 100%}75%{background-size:0 100%,50% 100%}to{background-size:0 100%,100% 100%}}@keyframes linkUnderlineAnimation{0%{background-size:100% 100%,0 100%}25%{background-size:50% 100%,0 100%}50%{background-size:0 100%,0 100%}75%{background-size:0 100%,50% 100%}to{background-size:0 100%,100% 100%}}.search-dropdown{border:1px solid #88acc3;position:relative}.search-dropdown:after{content:\"\";pointer-events:none;right:10px;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='xMinYMid' viewBox='0 0 32 32'%3E%3Cpath d='M21.3 29.4L7.9 16 21.3 2.6l2.8 2.8L13.5 16l10.6 10.6z' fill='%2388acc3'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:50%;background-size:auto 20px;-webkit-transform:rotate(270deg);-ms-transform:rotate(270deg);transform:rotate(270deg)}.search-dropdown-clear,.search-dropdown:after{width:20px;height:20px;position:absolute;top:calc(50% - 10px)}.search-dropdown-clear{font-size:25px;line-height:20px;cursor:pointer;color:#88acc3;text-align:center;right:36px}.search-dropdown-input{background:#fff;border:none;font-size:.875rem;line-height:17px;outline:none;padding:8px 56px 8px 12px;width:100%}.search-dropdown-input::-webkit-input-placeholder{color:#000}.search-dropdown-input::-moz-placeholder{color:#000}.search-dropdown-input::-ms-input-placeholder{color:#000}.search-dropdown-input::placeholder{color:#000}.search-dropdown-options{background:#fff;border-left:1px solid #88acc3;border-bottom:1px solid #88acc3;border-right:1px solid #88acc3;display:none;position:absolute;left:-1px;top:34px;width:calc(100% + 2px);max-height:230px;list-style:none;margin:0;padding:0;overflow-y:auto;z-index:3}.search-dropdown-options.visible{display:block}.search-dropdown-options li{cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;font-size:.875rem;height:23px;line-height:23px;padding:0 12px;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.search-dropdown-options li.search-dropdown-group-label{background:#ededed;cursor:default;text-transform:uppercase}.search-dropdown-options li.focused{background:#f3f7f9}.search-dropdown-options li.selected{background-color:#88acc3;color:#fff}.search-dropdown-options li.selected.focused{background-color:#e7eef3}.search-dropdown-options li:not(:last-of-type):not(.selected):after{content:\"\";background-color:#e7eef3;height:1px;width:calc(100% - 24px);position:absolute;left:12px;bottom:0}.search-dropdown-options li .search-dropdown-label{-webkit-box-flex:1;-ms-flex:1 1;flex:1 1;margin-right:4px;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap}.search-dropdown ::-webkit-scrollbar{width:4px;height:4px}.search-dropdown ::-webkit-scrollbar-track{background:#b0c8d8;border-radius:0}.search-dropdown ::-webkit-scrollbar-thumb{background:#5a84a0;border-radius:0}", ""]);

// exports


/***/ }),

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var ITEM_HEIGHT = 23;
var ITEM_COUNT = 10;
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      filter: '',
      active: false,
      focused: -1
    };
  },
  watch: {
    filter: function filter() {
      this.focus(this.focused);
    }
  },
  computed: {
    filteredItems: function filteredItems() {
      var _this = this;

      var filterAndSort = function filterAndSort(items) {
        return items.filter(function (item) {
          return item.selected || item.label.toLowerCase().indexOf(_this.filter.toLowerCase()) > -1;
        }).map(function (item, index) {
          // eslint-disable-next-line no-param-reassign
          item.sortIndex = index;
          return item;
        }).sort(function (a, b) {
          if (!_this.single) {
            if (_this.alphabetise && Boolean(a.selected) === Boolean(b.selected)) {
              return a.label.localeCompare(b.label, 'sl');
            }
            if (a.selected && !b.selected) return -1;else if (!a.selected && b.selected) return 1;
          }
          if (a.sortIndex < b.sortIndex) return -1;else if (a.sortIndex > b.sortIndex) return 1;
          return 0;
        }).map(function (item) {
          // eslint-disable-next-line no-param-reassign
          delete item.sortIndex;
          return item;
        });
      };
      if (this.groups) {
        return this.groups.map(function (group) {
          var itemsFromGroup = filterAndSort(_this.items.filter(function (item) {
            return group.items.indexOf(item.id) > -1;
          }));
          itemsFromGroup.forEach(function (item, index) {
            // eslint-disable-next-line no-param-reassign
            item.groupLabel = index === 0 ? group.label : null;
          });
          return itemsFromGroup;
        }).reduce(function (a, b) {
          return a.concat(b);
        }, []);
      }
      return filterAndSort(this.items);
    },
    selectedIds: function selectedIds() {
      return this.filteredItems.filter(function (item) {
        return item.selected;
      }).map(function (item) {
        return item.id;
      });
    },
    adjustedPlaceholder: function adjustedPlaceholder() {
      if (!this.single) {
        return this.placeholder;
      }
      var selectedItem = this.filteredItems.filter(function (item) {
        return item.selected;
      })[0];
      return selectedItem ? selectedItem.label : this.placeholder;
    }
  },
  directives: {
    clickOutside: {
      bind: function bind(el, binding) {
        var handler = function handler(e) {
          if (!el.contains(e.target) && el !== e.target) {
            binding.value(e);
          }
        };
        el.vueClickOutside = handler; // eslint-disable-line no-param-reassign
        document.addEventListener('click', handler);
      },
      unbind: function unbind(el) {
        document.removeEventListener('click', el.vueClickOutside);
        el.vueClickOutside = null; // eslint-disable-line no-param-reassign
      }
    }
  },
  props: {
    items: { type: Array, required: true },
    placeholder: { type: String, required: true },
    groups: { type: Array, required: false },
    alphabetise: { type: Boolean, required: false, default: true },
    single: { type: Boolean, required: false }
  },
  methods: {
    selectItem: function selectItem(selectedItemId) {
      if (this.single) {
        this.clearSelection();
        this.toggleItem(selectedItemId);
        this.toggleDropdown(false);
        this.$emit('change', this.items.find(function (item) {
          return item.id === selectedItemId;
        }));
      } else {
        this.toggleItem(selectedItemId);
      }
    },
    toggleItem: function toggleItem(itemId) {
      var clickedItem = this.items.filter(function (item) {
        return item.id === itemId;
      })[0];
      this.$set(clickedItem, 'selected', !clickedItem.selected);
    },
    toggleDropdown: function toggleDropdown(state) {
      if (state === false) {
        this.filter = '';
      }
      this.active = state;
    },
    clearSelection: function clearSelection() {
      this.selectedIds.forEach(this.toggleItem);
    },
    focus: function focus(index, withKeyboard) {
      this.focused = Math.max(Math.min(this.filteredItems.length - 1, index), -1);
      if (!withKeyboard) return;
      var additionalOffset = this.filteredItems.slice(0, this.focused + 1).map(function (item) {
        return item.groupLabel ? 1 : 0;
      }).reduce(function (a, b) {
        return a + b;
      }, 0);
      var optionListEl = this.$el.lastChild;
      var focusedPosition = (this.focused + additionalOffset) * ITEM_HEIGHT;
      if (focusedPosition < optionListEl.scrollTop) {
        optionListEl.scrollTop = focusedPosition;
      } else if (focusedPosition > optionListEl.scrollTop + (ITEM_COUNT - 1) * ITEM_HEIGHT) {
        optionListEl.scrollTop = focusedPosition - (ITEM_COUNT - 1) * ITEM_HEIGHT;
      }
    }
  }
});

/***/ }),

/***/ 39:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(function() { _vm.toggleDropdown(false) }),expression:"function() { toggleDropdown(false) }"}],staticClass:"search-dropdown"},[(_vm.selectedIds.length > 0)?_c('div',{staticClass:"search-dropdown-clear",on:{"click":_vm.clearSelection}},[_vm._v("×")]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"search-dropdown-input",attrs:{"type":"text","placeholder":_vm.adjustedPlaceholder},domProps:{"value":(_vm.filter)},on:{"focus":function($event){_vm.toggleDropdown(true)},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }$event.preventDefault();_vm.focused !== -1 && _vm.selectItem(_vm.filteredItems[_vm.focused].id)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38,$event.key)){ return null; }$event.preventDefault();_vm.toggleDropdown(true), _vm.focus(_vm.focused - 1, true)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40,$event.key)){ return null; }$event.preventDefault();_vm.toggleDropdown(true), _vm.focus(_vm.focused + 1, true)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"tab",9,$event.key)){ return null; }_vm.toggleDropdown(false)}],"input":[function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value},function($event){_vm.toggleDropdown(true)}]}}),_vm._v(" "),_c('ul',{class:['search-dropdown-options', { visible: this.active }],on:{"mouseleave":function($event){_vm.focus(-1)}}},[_vm._l((_vm.filteredItems),function(item, index){return [(item.groupLabel)?_c('li',{staticClass:"search-dropdown-group-label"},[_vm._v("\n        "+_vm._s(item.groupLabel)+"\n      ")]):_vm._e(),_vm._v(" "),_c('li',{class:{ selected : item.selected, focused : _vm.focused === index },on:{"click":function($event){_vm.selectItem(item.id)},"mouseenter":function($event){_vm.focus(index)}}},[_c('div',{staticClass:"search-dropdown-label"},[_vm._v(_vm._s(item.label))]),_vm._v(" "),(item.count)?_c('div',[_vm._v(_vm._s(item.count))]):_vm._e()])]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 440:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_js_tooltip__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_js_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap_js_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SearchDropdown_vue__ = __webpack_require__(35);






function DonutChart(options) {
  this.settings = __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.extend({
    element: options.element,
    percent: 100
  }, options);

  this.circle = this.settings.element.find('path');
  this.circleBg = this.settings.elementBg.find('path');
  this.settings.stroke_width = parseInt(this.circle.css('stroke-width'), 10);
  this.radius = (parseInt(this.settings.element.css('width'), 10) / 1 - this.settings.stroke_width) / 2;
  this.angle = -97.5; // Origin of the draw at the top of the circle
  this.i = Math.round(0.75 * this.settings.percent);
  this.iBg = Math.round(0.75 * 100);
  this.first = true;

  this.animate = function () {
    // this.timer = setInterval(this.loop.bind(this), 10);
    this.loop();
  };

  this.loop = function loop() {
    this.angle += 5;
    this.angle %= 360;
    var radians = this.angle / 180 * Math.PI;
    var x = this.radius + this.settings.stroke_width / 2 + Math.cos(radians) * this.radius;
    var y = this.radius + this.settings.stroke_width / 2 + Math.sin(radians) * this.radius;
    var d = void 0;
    var dBg = void 0;
    if (this.first === true) {
      if (this.i > 0) {
        d = this.circle.attr('d') + ' M ' + x + ' ' + y;
      }
      dBg = this.circleBg.attr('d') + ' M ' + x + ' ' + y;
      this.first = false;
    } else {
      if (this.i > 0) {
        d = this.circle.attr('d') + ' L ' + x + ' ' + y;
      }
      dBg = this.circleBg.attr('d') + ' L ' + x + ' ' + y;
    }
    if (this.i > 0 && d) {
      this.circle.attr('d', d);
    }
    this.circleBg.attr('d', dBg);
    this.i -= 1;
    this.iBg -= 1;

    if (this.iBg <= 0) {
      // clearInterval(this.timer);
    } else {
      this.loop();
    }
  };
}

__WEBPACK_IMPORTED_MODULE_1_jquery___default()(function () {
  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.donut-chart').each(function createChart(index) {
    var percent = parseInt(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).attr('data-percent'), 10);
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).append('<svg preserveAspectRatio="xMidYMid" id="donutChartSVG' + index + '-bg" class="donut-chart-bg"><path d="M100,100" /></svg>');
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).append('<svg preserveAspectRatio="xMidYMid" id="donutChartSVG' + index + '"><path d="M100,100" /></svg>');
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).append('<p class="middle-text">' + percent + '%</p>');
    var p = new DonutChart({
      element: __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#donutChartSVG' + index),
      elementBg: __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#donutChartSVG' + index + '-bg'),
      percent: percent
    });
    p.animate();
  });
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  created: function created() {
    var path = decodeURIComponent(window.location.pathname);
    var match = path.match(/\/predpisi\/([\wčšž-]+)\/$/);
    if (match && match[1]) {
      var ministryId = this.ministryIdFromSlug(match[1]);
      var ministry = this.filterMinistries.find(function (e) {
        return e.id === ministryId;
      });
      if (ministry) {
        ministry.selected = true;
      }
    }
  },

  data: {
    // eslint-disable-next-line no-underscore-dangle
    violationsByMinistry: window.__violations_by_ministry__ || [],
    violationsByMinistryLastUpdate: [],
    sortKey: window.__all_acts__ ? 'id' : 'violations.percent', // eslint-disable-line no-underscore-dangle
    sortReverse: true,
    showTimeRange: 'all-time',
    filterMinistries: [{ id: 0, label: 'Ministrstvo za demografijo, družino in socialne zadeve', abbr: 'MDDSZ' }, { id: 1, label: 'Ministrstvo za finance', abbr: 'MF' }, { id: 2, label: 'Ministrstvo za gospodarstvo, delo in šport', abbr: 'MGDŠ' }, { id: 3, label: 'Ministrstvo za infrastrukturo in energetiko', abbr: 'MIE' }, { id: 4, label: 'Ministrstvo za izobraževanje, znanost in mladino', abbr: 'MIZM' }, { id: 5, label: 'Ministrstvo za kmetijstvo', abbr: 'MKGP' }, { id: 6, label: 'Ministrstvo za kulturo', abbr: 'MK' }, { id: 7, label: 'Ministrstvo za lokalno samoupravo, kohezijo in regionalni razvoj', abbr: 'MLSKRR' }, { id: 8, label: 'Ministrstvo za notranje zadeve in javno upravo', abbr: 'MNZJU' }, { id: 9, label: 'Ministrstvo za obrambo', abbr: 'MO' }, { id: 10, label: 'Ministrstvo za okolje in prostor', abbr: 'MOP' }, { id: 11, label: 'Ministrstvo za pravosodje', abbr: 'MP' }, { id: 12, label: 'Ministrstvo za zdravje', abbr: 'MZ' }, { id: 13, label: 'Ministrstvo za zunanje in evropske zadeve', abbr: 'MZZ' }],
    filterTimeRange: [{ id: 0, label: 'Cel mandat', selected: true }, { id: 1, label: 'Zadnja objava' }],
    filterViolationType: [{ id: 0, label: 'Brez javne razprave' }, { id: 1, label: 'Brez roka za pripombe' }, { id: 2, label: 'Prekratek rok za pripombe' }, { id: 3, label: 'Ne krši ReNDej' }],
    allActs: window.__all_acts__ || [], // eslint-disable-line no-underscore-dangle
    lastUpdate: {
      start: window.__last_update_start__ ? window.__last_update_start__.split('T')[0] : '', // eslint-disable-line no-underscore-dangle
      end: window.__last_update_end__ ? window.__last_update_end__.split('T')[0] : '' // eslint-disable-line no-underscore-dangle
    }
  },
  computed: {
    sortedViolationsByMinistry: function sortedViolationsByMinistry() {
      var _this = this;

      if (this.showTimeRange === 'all-time') {
        if (this.violationsByMinistry) {
          var sorted = this.violationsByMinistry;
          if (this.sortKey) {
            sorted = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(sorted, [function (o) {
              var val = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(o, _this.sortKey);
              if (typeof val === 'string') {
                return val.toLowerCase();
              }
              return val;
            }]);
            if (this.sortReverse) {
              sorted = sorted.reverse();
            }
          }
          return sorted;
        }
        return this.violationsByMinistry;
      }
      if (this.violationsByMinistryLastUpdate) {
        var _sorted = this.violationsByMinistryLastUpdate;
        if (this.sortKey) {
          _sorted = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(_sorted, [function (o) {
            var val = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(o, _this.sortKey);
            if (typeof val === 'string') {
              return val.toLowerCase();
            }
            return val;
          }]);
          if (this.sortReverse) {
            _sorted = _sorted.reverse();
          }
        }
        return _sorted;
      }
      return this.violationsByMinistryLastUpdate;
    },
    filterMinistriesSelected: function filterMinistriesSelected() {
      return this.filterMinistries.filter(function (e) {
        return e.selected;
      });
    },
    filterMinistriesPlaceholder: function filterMinistriesPlaceholder() {
      var selected = this.filterMinistriesSelected.length;
      if (!selected || selected === this.filterMinistries.length) {
        return 'Vsa ministrstva';
      }
      return 'Izbrana ministrstva: ' + selected;
    },
    filterTimeRangeSelected: function filterTimeRangeSelected() {
      return this.filterTimeRange.filter(function (e) {
        return e.selected;
      });
    },
    filterTimeRangePlaceholder: function filterTimeRangePlaceholder() {
      return this.filterTimeRangeSelected.length ? '' + this.filterTimeRangeSelected[0].label : 'Izberite časovni razpon';
    },
    filterViolationTypeSelected: function filterViolationTypeSelected() {
      return this.filterViolationType.filter(function (e) {
        return e.selected;
      });
    },
    filterViolationTypePlaceholder: function filterViolationTypePlaceholder() {
      var selected = this.filterViolationTypeSelected.length;
      if (!selected || selected === this.filterViolationType.length) {
        return 'Vse kršitve';
      }
      return 'Izbrane kr\u0161itve: ' + selected;
    },
    sortedAllActs: function sortedAllActs() {
      var _this2 = this;

      if (this.allActs) {
        var sorted = this.allActs;
        if (this.filterMinistriesSelected.length) {
          sorted = sorted.filter(function (e) {
            return _this2.filterMinistriesSelected.some(function (v) {
              return v.id === e.ministrstvo;
            });
          });
        }
        if (this.filterTimeRangeSelected.length && this.filterTimeRangeSelected[0].id === 1) {
          // TODO: time range
          sorted = sorted.filter(function (e) {
            return e.datum_od >= _this2.lastUpdate.start;
          });
        }
        if (this.filterViolationTypeSelected.length) {
          sorted = sorted.filter(function (e) {
            var k = _this2.getViolationDisplay(e.krsitev);
            return _this2.filterViolationTypeSelected.some(function (v) {
              return v.label === k;
            });
          });
        }
        if (this.sortKey) {
          sorted = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(sorted, [function (o) {
            var val = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(o, _this2.sortKey);
            if (typeof val === 'string') {
              return val.toLowerCase();
            }
            return val;
          }]);
          if (this.sortReverse) {
            sorted = sorted.reverse();
          }
        }
        return sorted;
      }
      return this.allActs;
    }
  },
  watch: {
    showTimeRange: function showTimeRange(value) {
      if (value === 'all-time' && !this.violationsByMinistry.length) {
        this.fetchData('/stevec-krsitev/getViolationsByMinistry/', 'violationsByMinistry');
      } else if (value === 'last-update' && !this.violationsByMinistryLastUpdate.length) {
        this.fetchData('/stevec-krsitev/getViolationsByMinistryLastUpdate/', 'violationsByMinistryLastUpdate');
      }
    },
    sortedViolationsByMinistry: function sortedViolationsByMinistry(value, oldValue) {
      if (oldValue != null) {
        this.announceTableChanged();
      }
    },
    sortedAllActs: function sortedAllActs(value, oldValue) {
      if (oldValue != null) {
        this.announceTableChanged();
      }
    }
  },
  methods: {
    announceTableChanged: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function announceTableChanged() {
      if (typeof window != 'undefined') {
        console.log("table changed!");
        var $body = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(document.body);
        $body.append('<div class="sr-only" aria-live="polite">Vsebina tabele spremenjena.</div>');
      }
    }, 1000),
    sortBy: function sortBy(key) {
      if (this.sortKey === key) {
        this.sortReverse = !this.sortReverse;
      } else {
        this.sortKey = key;
        this.sortReverse = false;
      }
    },
    fetchData: function fetchData(url, key) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.getJSON(url).done(function (data) {
        data.forEach(function (e) {
          if (!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isArray(e.countries)) {
            e.countries = [e.countries];
          }
        });
        _this3[key] = data;
      }).fail(function () {
        var arr = [];
        arr.error = true;
        _this3[key] = arr;
      });
    },
    getViolationDisplay: function getViolationDisplay(violation) {
      switch (violation) {
        case 'prekratek_rok':
          return 'Prekratek rok za pripombe';
        case 'brez_roka':
          return 'Brez roka za pripombe';
        case 'brez_razprave':
          return 'Brez javne razprave';
        case 'ok':
          return 'Ne krši ReNDej';
        default:
          return '';
      }
    },
    getDateDisplay: function getDateDisplay(dateFrom, dateTo) {
      if (dateFrom) {
        var dateFromString = new Date(dateFrom).toLocaleDateString('sl');
        if (dateTo) {
          return dateFromString + ' - ' + new Date(dateTo).toLocaleDateString('sl');
        }
        return dateFromString;
      }
      return '/';
    },
    getMinistryDisplay: function getMinistryDisplay(ministry) {
      var m = this.filterMinistries.find(function (e) {
        return e.id === ministry;
      });
      if (m) {
        return m.label;
      }
      return '';
    },
    getMinistryDisplayAbbr: function getMinistryDisplayAbbr(ministry) {
      var m = this.filterMinistries.find(function (e) {
        return e.id === ministry;
      });
      if (m) {
        return m.abbr;
      }
      return '';
    },
    formatDuration: function formatDuration(duration) {
      if (duration === 1) {
        return '1 dan';
      } else if (duration > 1) {
        return duration + ' dni';
      }
      return '/';
    },
    slugify: function slugify(string) {
      return String(string).trim().toLowerCase().replace(/[^\wčšž]+/gi, '-');
    },
    openActsForMinistry: function openActsForMinistry(ministry) {
      var slug = this.slugify(ministry);
      window.location.assign('/stevec-krsitev/predpisi/' + slug + '/');
    },
    ministryIdFromSlug: function ministryIdFromSlug(ministrySlug) {
      var _this4 = this;

      var m = this.filterMinistries.find(function (e) {
        return _this4.slugify(e.label) === ministrySlug;
      });
      return m ? m.id : -1;
    }
  },
  directives: {
    sortarrow: {
      bind: function bind(el, binding, vnode) {
        el.sortArrowListener = function () {
          vnode.context.sortBy(binding.value);
        };
        el.addEventListener('click', el.sortArrowListener);
        el.classList.add('sortarrow');
        if (binding.value === vnode.context.sortKey) {
          el.classList.add('sortarrow--active');
          if (vnode.context.sortReverse) {
            el.classList.add('sortarrow--reverse');
          } else {
            el.classList.remove('sortarrow--reverse');
          }
        } else {
          el.classList.remove('sortarrow--active');
          el.classList.remove('sortarrow--reverse');
        }
      },
      update: function update(el, binding, vnode) {
        if (binding.value === vnode.context.sortKey) {
          el.classList.add('sortarrow--active');
          if (vnode.context.sortReverse) {
            el.classList.add('sortarrow--reverse');
          } else {
            el.classList.remove('sortarrow--reverse');
          }
        } else {
          el.classList.remove('sortarrow--active');
          el.classList.remove('sortarrow--reverse');
        }
      },
      unbind: function unbind(el) {
        el.removeEventListener('click', el.sortArrowListener);
        el.sortArrowListener = null;
      }
    }
  },
  components: {
    SearchDropdown: __WEBPACK_IMPORTED_MODULE_4__components_SearchDropdown_vue__["a" /* default */]
  }
});

window.app = app;

__WEBPACK_IMPORTED_MODULE_1_jquery___default()('[data-toggle="tooltip"]').tooltip({
  container: 'body'
});

/***/ })

},[440]);


// WEBPACK FOOTER //
// js/stevec.e4d602590e6b45312e31.js